var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5356 5H15.4681C15.6801 5 15.7959 5.24721 15.6602 5.41005L13.6939 7.76953C13.594 7.88947 13.4098 7.88947 13.3098 7.76953L11.3436 5.41005C11.2079 5.24721 11.3237 5 11.5356 5Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.535634 7H4.46811C4.68007 7 4.79586 6.75279 4.66017 6.58995L2.69393 4.23047C2.59398 4.11053 2.40977 4.11053 2.30982 4.23047L0.343579 6.58995C0.207886 6.75279 0.323675 7 0.535634 7Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00188 1C6.44938 1 5.06244 1.70697 4.14456 2.81839C3.96872 3.03131 3.65357 3.06137 3.44065 2.88552C3.22773 2.70968 3.19767 2.39453 3.37351 2.18161C4.47322 0.850027 6.13849 0 8.00188 0C10.9436 0 13.3899 2.1165 13.903 4.90967C13.9085 4.9397 13.9138 4.96981 13.9188 5H12.902C12.4389 2.71778 10.4205 1 8.00188 1ZM3.10179 7C3.5648 9.28222 5.58325 11 8.00188 11C9.55437 11 10.9413 10.293 11.8592 9.18161C12.035 8.96869 12.3502 8.93863 12.5631 9.11448C12.776 9.29032 12.8061 9.60547 12.6302 9.81839C11.5305 11.15 9.86526 12 8.00188 12C5.06017 12 2.61385 9.8835 2.10079 7.09033C2.09527 7.0603 2.08998 7.03019 2.08491 7H3.10179Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.5c189da2445a8748179759c1641cd5cc.svg";
export { ForwardRef as ReactComponent };